// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__2Uwub","item":"List_item__1LM5q"};